// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Smooth theme transition */
.theme-transition * {
  transition: background-color 0.3s ease, color 0.3s ease, border-color 0.3s ease, box-shadow 0.3s ease !important;
}

/* Dark mode styles */
.dark-mode {
  background-color: #121212 !important;
  color: #ffffff !important;
}

.dark-mode html {
  background-color: #121212 !important;
}

.dark-mode body {
  background-color: #121212 !important;
  color: #ffffff !important;
}

/* Ensure all major layout elements have dark background */
.dark-mode main,
.dark-mode [role="main"],
.dark-mode .MuiBox-root {
  background-color: #121212 !important;
}

/* Handle containers with Tailwind's min-h-screen */
.dark-mode .min-h-screen {
  background-color: #1e1e1e !important;
}

.dark-mode .h-full,
.dark-mode .h-screen {
  background-color: #1e1e1e !important;
}

/* Border colors in dark mode */
.dark-mode .border-gray-200,
.dark-mode .border-gray-300,
.dark-mode .border-gray-400 {
  border-color: #444444 !important;
}

.dark-mode .divide-gray-200 {
  border-color: #444444 !important;
}

.dark-mode .MuiPaper-root {
  background-color: #1e1e1e !important;
  color: #ffffff !important;
}

.dark-mode .MuiAppBar-root {
  background-color: #1e1e1e !important;
}

.dark-mode .MuiDrawer-paper {
  background-color: #1e1e1e !important;
  border-right: 1px solid #333333 !important;
}

.dark-mode .MuiCard-root {
  background-color: #1e1e1e !important;
  color: #ffffff !important;
}

.dark-mode .MuiListItemText-primary {
  color: #ffffff !important;
}

.dark-mode .MuiListItemText-secondary {
  color: #b0b0b0 !important;
}

.dark-mode .MuiTypography-root {
  color: #ffffff !important;
}

/* Custom scrollbar for dark mode */
.dark-mode ::-webkit-scrollbar {
  width: 8px;
}

.dark-mode ::-webkit-scrollbar-track {
  background: #2d2d2d;
}

.dark-mode ::-webkit-scrollbar-thumb {
  background: #555;
  border-radius: 4px;
}

.dark-mode ::-webkit-scrollbar-thumb:hover {
  background: #777;
}

/* Input fields and form elements in dark mode */
.dark-mode .MuiTextField-root input,
.dark-mode .MuiInput-root input,
.dark-mode .MuiOutlinedInput-root input,
.dark-mode .MuiFilledInput-root input {
  color: #ffffff !important;
  caret-color: #3B82F6;
}

.dark-mode .MuiOutlinedInput-root {
  color: #ffffff !important;
}

.dark-mode .MuiOutlinedInput-root fieldset {
  border-color: #444444 !important;
}

.dark-mode .MuiOutlinedInput-root:hover fieldset {
  border-color: #666666 !important;
}

.dark-mode .MuiOutlinedInput-root.Mui-focused fieldset {
  border-color: #3B82F6 !important;
}

/* Table styling in dark mode */
.dark-mode .MuiTable-root td,
.dark-mode .MuiTable-root th {
  color: #ffffff;
  border-bottom-color: #444444 !important;
}

.dark-mode .MuiTableHead-root {
  background-color: #1e1e1e;
}

.dark-mode .MuiTableBody-root tr:hover {
  background-color: rgba(255, 255, 255, 0.05) !important;
}

/* Dialog and modals in dark mode */
.dark-mode .MuiDialog-paper {
  background-color: #1e1e1e !important;
  color: #ffffff !important;
}

.dark-mode .MuiModal-backdrop {
  background-color: rgba(0, 0, 0, 0.7);
}

/* Menu and popover in dark mode */
.dark-mode .MuiPopover-paper,
.dark-mode .MuiMenu-paper {
  background-color: #1e1e1e !important;
  color: #ffffff !important;
}

.dark-mode .MuiMenuItem-root {
  color: #ffffff;
}

.dark-mode .MuiMenuItem-root:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

/* Chip in dark mode */
.dark-mode .MuiChip-root {
  background-color: #333333 !important;
  color: #ffffff !important;
}

.dark-mode .MuiChip-outlined {
  border-color: #666666 !important;
}

/* Tabs in dark mode */
.dark-mode .MuiTabs-indicator {
  background-color: #3B82F6 !important;
}

.dark-mode .MuiTab-root {
  color: #b0b0b0 !important;
}

.dark-mode .MuiTab-root.Mui-selected {
  color: #ffffff !important;
}

/* Select field in dark mode */
.dark-mode .MuiSelect-select {
  color: #ffffff !important;
}

.dark-mode .MuiNativeSelect-select {
  color: #ffffff !important;
  background-color: #1e1e1e !important;
}

/* Button in dark mode */
.dark-mode .MuiButton-outlined {
  border-color: #666666;
  color: #ffffff;
}

.dark-mode .MuiButton-outlined:hover {
  background-color: rgba(255, 255, 255, 0.1);
  border-color: #3B82F6;
}

.dark-mode .MuiButton-text {
  color: #ffffff;
}

/* Link in dark mode */
.dark-mode a {
  color: #60A5FA;
}

.dark-mode a:hover {
  color: #93C5FD;
}

/* Override Tailwind white backgrounds in dark mode */
.dark-mode .bg-white {
  background-color: #1e1e1e !important;
}

.dark-mode .bg-gray-50,
.dark-mode .bg-gray-100,
.dark-mode .bg-gray-200,
.dark-mode .bg-gray-300,
.dark-mode .bg-gray-400 {
  background-color: #1e1e1e !important;
}

.dark-mode .text-gray-900,
.dark-mode .text-gray-800,
.dark-mode .text-gray-700,
.dark-mode .text-gray-600,
.dark-mode .text-gray-500,
.dark-mode .text-gray-400,
.dark-mode .text-gray-300 {
  color: #ffffff !important;
}

.dark-mode .text-black {
  color: #ffffff !important;
}

/* Override slate colors too */
.dark-mode .bg-slate-50,
.dark-mode .bg-slate-100,
.dark-mode .bg-slate-200,
.dark-mode .bg-slate-300 {
  background-color: #1e1e1e !important;
}

.dark-mode .text-slate-900,
.dark-mode .text-slate-800,
.dark-mode .text-slate-700,
.dark-mode .text-slate-600,
.dark-mode .text-slate-500 {
  color: #ffffff !important;
}

/* Override neutral colors */
.dark-mode .bg-neutral-50,
.dark-mode .bg-neutral-100,
.dark-mode .bg-neutral-200 {
  background-color: #1e1e1e !important;
}

.dark-mode .text-neutral-900,
.dark-mode .text-neutral-800,
.dark-mode .text-neutral-700,
.dark-mode .text-neutral-600 {
  color: #ffffff !important;
}

/* Divider in dark mode */
.dark-mode .MuiDivider-root {
  border-color: #444444 !important;
}

/* Alert in dark mode */
.dark-mode .MuiAlert-standardInfo {
  background-color: rgba(59, 130, 246, 0.1) !important;
  color: #ffffff !important;
}

.dark-mode .MuiAlert-standardSuccess {
  background-color: rgba(16, 185, 129, 0.1) !important;
  color: #ffffff !important;
}

.dark-mode .MuiAlert-standardWarning {
  background-color: rgba(202, 138, 4, 0.1) !important;
  color: #ffffff !important;
}

.dark-mode .MuiAlert-standardError {
  background-color: rgba(220, 38, 38, 0.1) !important;
  color: #ffffff !important;
}

/* Tooltip in dark mode */
.dark-mode .MuiTooltip-tooltip {
  background-color: #333333;
  color: #ffffff;
}

/* Stepper in dark mode */
.dark-mode .MuiStepIcon-root {
  color: #444444;
}

.dark-mode .MuiStepIcon-root.Mui-active {
  color: #3B82F6;
}

.dark-mode .MuiStepConnector-line {
  border-color: #444444;
}

/* Progress bar in dark mode */
.dark-mode .MuiLinearProgress-root {
  background-color: #333333;
}

/* Skeleton loader in dark mode */
.dark-mode .MuiSkeleton-root {
  background-color: #333333;
}
`, "",{"version":3,"sources":["webpack://./src/styles/dark-mode.css"],"names":[],"mappings":"AAAA,4BAA4B;AAC5B;EACE,gHAAgH;AAClH;;AAEA,qBAAqB;AACrB;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA,0DAA0D;AAC1D;;;EAGE,oCAAoC;AACtC;;AAEA,mDAAmD;AACnD;EACE,oCAAoC;AACtC;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA,+BAA+B;AAC/B;;;EAGE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;EACpC,0CAA0C;AAC5C;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,mCAAmC;AACnC;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,gDAAgD;AAChD;;;;EAIE,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA,+BAA+B;AAC/B;;EAEE,cAAc;EACd,uCAAuC;AACzC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sDAAsD;AACxD;;AAEA,mCAAmC;AACnC;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;;AAEA,kCAAkC;AAClC;;EAEE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA,sBAAsB;AACtB;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;AAClC;;AAEA,sBAAsB;AACtB;EACE,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,8BAA8B;AAC9B;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA,wBAAwB;AACxB;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,0CAA0C;EAC1C,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,qDAAqD;AACrD;EACE,oCAAoC;AACtC;;AAEA;;;;;EAKE,oCAAoC;AACtC;;AAEA;;;;;;;EAOE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,8BAA8B;AAC9B;;;;EAIE,oCAAoC;AACtC;;AAEA;;;;;EAKE,yBAAyB;AAC3B;;AAEA,4BAA4B;AAC5B;;;EAGE,oCAAoC;AACtC;;AAEA;;;;EAIE,yBAAyB;AAC3B;;AAEA,yBAAyB;AACzB;EACE,gCAAgC;AAClC;;AAEA,uBAAuB;AACvB;EACE,oDAAoD;EACpD,yBAAyB;AAC3B;;AAEA;EACE,oDAAoD;EACpD,yBAAyB;AAC3B;;AAEA;EACE,mDAAmD;EACnD,yBAAyB;AAC3B;;AAEA;EACE,mDAAmD;EACnD,yBAAyB;AAC3B;;AAEA,yBAAyB;AACzB;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA,yBAAyB;AACzB;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA,8BAA8B;AAC9B;EACE,yBAAyB;AAC3B;;AAEA,iCAAiC;AACjC;EACE,yBAAyB;AAC3B","sourcesContent":["/* Smooth theme transition */\n.theme-transition * {\n  transition: background-color 0.3s ease, color 0.3s ease, border-color 0.3s ease, box-shadow 0.3s ease !important;\n}\n\n/* Dark mode styles */\n.dark-mode {\n  background-color: #121212 !important;\n  color: #ffffff !important;\n}\n\n.dark-mode html {\n  background-color: #121212 !important;\n}\n\n.dark-mode body {\n  background-color: #121212 !important;\n  color: #ffffff !important;\n}\n\n/* Ensure all major layout elements have dark background */\n.dark-mode main,\n.dark-mode [role=\"main\"],\n.dark-mode .MuiBox-root {\n  background-color: #121212 !important;\n}\n\n/* Handle containers with Tailwind's min-h-screen */\n.dark-mode .min-h-screen {\n  background-color: #1e1e1e !important;\n}\n\n.dark-mode .h-full,\n.dark-mode .h-screen {\n  background-color: #1e1e1e !important;\n}\n\n/* Border colors in dark mode */\n.dark-mode .border-gray-200,\n.dark-mode .border-gray-300,\n.dark-mode .border-gray-400 {\n  border-color: #444444 !important;\n}\n\n.dark-mode .divide-gray-200 {\n  border-color: #444444 !important;\n}\n\n.dark-mode .MuiPaper-root {\n  background-color: #1e1e1e !important;\n  color: #ffffff !important;\n}\n\n.dark-mode .MuiAppBar-root {\n  background-color: #1e1e1e !important;\n}\n\n.dark-mode .MuiDrawer-paper {\n  background-color: #1e1e1e !important;\n  border-right: 1px solid #333333 !important;\n}\n\n.dark-mode .MuiCard-root {\n  background-color: #1e1e1e !important;\n  color: #ffffff !important;\n}\n\n.dark-mode .MuiListItemText-primary {\n  color: #ffffff !important;\n}\n\n.dark-mode .MuiListItemText-secondary {\n  color: #b0b0b0 !important;\n}\n\n.dark-mode .MuiTypography-root {\n  color: #ffffff !important;\n}\n\n/* Custom scrollbar for dark mode */\n.dark-mode ::-webkit-scrollbar {\n  width: 8px;\n}\n\n.dark-mode ::-webkit-scrollbar-track {\n  background: #2d2d2d;\n}\n\n.dark-mode ::-webkit-scrollbar-thumb {\n  background: #555;\n  border-radius: 4px;\n}\n\n.dark-mode ::-webkit-scrollbar-thumb:hover {\n  background: #777;\n}\n\n/* Input fields and form elements in dark mode */\n.dark-mode .MuiTextField-root input,\n.dark-mode .MuiInput-root input,\n.dark-mode .MuiOutlinedInput-root input,\n.dark-mode .MuiFilledInput-root input {\n  color: #ffffff !important;\n  caret-color: #3B82F6;\n}\n\n.dark-mode .MuiOutlinedInput-root {\n  color: #ffffff !important;\n}\n\n.dark-mode .MuiOutlinedInput-root fieldset {\n  border-color: #444444 !important;\n}\n\n.dark-mode .MuiOutlinedInput-root:hover fieldset {\n  border-color: #666666 !important;\n}\n\n.dark-mode .MuiOutlinedInput-root.Mui-focused fieldset {\n  border-color: #3B82F6 !important;\n}\n\n/* Table styling in dark mode */\n.dark-mode .MuiTable-root td,\n.dark-mode .MuiTable-root th {\n  color: #ffffff;\n  border-bottom-color: #444444 !important;\n}\n\n.dark-mode .MuiTableHead-root {\n  background-color: #1e1e1e;\n}\n\n.dark-mode .MuiTableBody-root tr:hover {\n  background-color: rgba(255, 255, 255, 0.05) !important;\n}\n\n/* Dialog and modals in dark mode */\n.dark-mode .MuiDialog-paper {\n  background-color: #1e1e1e !important;\n  color: #ffffff !important;\n}\n\n.dark-mode .MuiModal-backdrop {\n  background-color: rgba(0, 0, 0, 0.7);\n}\n\n/* Menu and popover in dark mode */\n.dark-mode .MuiPopover-paper,\n.dark-mode .MuiMenu-paper {\n  background-color: #1e1e1e !important;\n  color: #ffffff !important;\n}\n\n.dark-mode .MuiMenuItem-root {\n  color: #ffffff;\n}\n\n.dark-mode .MuiMenuItem-root:hover {\n  background-color: rgba(255, 255, 255, 0.1);\n}\n\n/* Chip in dark mode */\n.dark-mode .MuiChip-root {\n  background-color: #333333 !important;\n  color: #ffffff !important;\n}\n\n.dark-mode .MuiChip-outlined {\n  border-color: #666666 !important;\n}\n\n/* Tabs in dark mode */\n.dark-mode .MuiTabs-indicator {\n  background-color: #3B82F6 !important;\n}\n\n.dark-mode .MuiTab-root {\n  color: #b0b0b0 !important;\n}\n\n.dark-mode .MuiTab-root.Mui-selected {\n  color: #ffffff !important;\n}\n\n/* Select field in dark mode */\n.dark-mode .MuiSelect-select {\n  color: #ffffff !important;\n}\n\n.dark-mode .MuiNativeSelect-select {\n  color: #ffffff !important;\n  background-color: #1e1e1e !important;\n}\n\n/* Button in dark mode */\n.dark-mode .MuiButton-outlined {\n  border-color: #666666;\n  color: #ffffff;\n}\n\n.dark-mode .MuiButton-outlined:hover {\n  background-color: rgba(255, 255, 255, 0.1);\n  border-color: #3B82F6;\n}\n\n.dark-mode .MuiButton-text {\n  color: #ffffff;\n}\n\n/* Link in dark mode */\n.dark-mode a {\n  color: #60A5FA;\n}\n\n.dark-mode a:hover {\n  color: #93C5FD;\n}\n\n/* Override Tailwind white backgrounds in dark mode */\n.dark-mode .bg-white {\n  background-color: #1e1e1e !important;\n}\n\n.dark-mode .bg-gray-50,\n.dark-mode .bg-gray-100,\n.dark-mode .bg-gray-200,\n.dark-mode .bg-gray-300,\n.dark-mode .bg-gray-400 {\n  background-color: #1e1e1e !important;\n}\n\n.dark-mode .text-gray-900,\n.dark-mode .text-gray-800,\n.dark-mode .text-gray-700,\n.dark-mode .text-gray-600,\n.dark-mode .text-gray-500,\n.dark-mode .text-gray-400,\n.dark-mode .text-gray-300 {\n  color: #ffffff !important;\n}\n\n.dark-mode .text-black {\n  color: #ffffff !important;\n}\n\n/* Override slate colors too */\n.dark-mode .bg-slate-50,\n.dark-mode .bg-slate-100,\n.dark-mode .bg-slate-200,\n.dark-mode .bg-slate-300 {\n  background-color: #1e1e1e !important;\n}\n\n.dark-mode .text-slate-900,\n.dark-mode .text-slate-800,\n.dark-mode .text-slate-700,\n.dark-mode .text-slate-600,\n.dark-mode .text-slate-500 {\n  color: #ffffff !important;\n}\n\n/* Override neutral colors */\n.dark-mode .bg-neutral-50,\n.dark-mode .bg-neutral-100,\n.dark-mode .bg-neutral-200 {\n  background-color: #1e1e1e !important;\n}\n\n.dark-mode .text-neutral-900,\n.dark-mode .text-neutral-800,\n.dark-mode .text-neutral-700,\n.dark-mode .text-neutral-600 {\n  color: #ffffff !important;\n}\n\n/* Divider in dark mode */\n.dark-mode .MuiDivider-root {\n  border-color: #444444 !important;\n}\n\n/* Alert in dark mode */\n.dark-mode .MuiAlert-standardInfo {\n  background-color: rgba(59, 130, 246, 0.1) !important;\n  color: #ffffff !important;\n}\n\n.dark-mode .MuiAlert-standardSuccess {\n  background-color: rgba(16, 185, 129, 0.1) !important;\n  color: #ffffff !important;\n}\n\n.dark-mode .MuiAlert-standardWarning {\n  background-color: rgba(202, 138, 4, 0.1) !important;\n  color: #ffffff !important;\n}\n\n.dark-mode .MuiAlert-standardError {\n  background-color: rgba(220, 38, 38, 0.1) !important;\n  color: #ffffff !important;\n}\n\n/* Tooltip in dark mode */\n.dark-mode .MuiTooltip-tooltip {\n  background-color: #333333;\n  color: #ffffff;\n}\n\n/* Stepper in dark mode */\n.dark-mode .MuiStepIcon-root {\n  color: #444444;\n}\n\n.dark-mode .MuiStepIcon-root.Mui-active {\n  color: #3B82F6;\n}\n\n.dark-mode .MuiStepConnector-line {\n  border-color: #444444;\n}\n\n/* Progress bar in dark mode */\n.dark-mode .MuiLinearProgress-root {\n  background-color: #333333;\n}\n\n/* Skeleton loader in dark mode */\n.dark-mode .MuiSkeleton-root {\n  background-color: #333333;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
